<script>
    import { createEventDispatcher, onDestroy } from 'svelte';
    import { getApiBase } from './apiBase.js';

    export let channel;
    export let inactive = false;
    $: studentGroup = inactive ? 'Inactive students' : 'Active students';
    const dispatch = createEventDispatcher();
    let startDate = '';
    let endDate = '';
    let isLoading = false;
    let errorMessage = '';
    let appliedRange = '';
    let requestVersion = 0;

    function resetRange() {
        requestVersion += 1;
        isLoading = false;
        errorMessage = '';
        appliedRange = '';
        dispatch('recipients', []);
    }

    async function applyRange() {
        resetRange();
        if (!startDate || !endDate) {
            errorMessage = 'Choose both a start date and an end date.';
            return;
        }
        if (startDate > endDate) {
            errorMessage = 'Start date must be on or before end date.';
            return;
        }
        const version = requestVersion;
        const range = `${startDate} to ${endDate}`;
        isLoading = true;
        try {
            const query = new URLSearchParams({ start_date: startDate, end_date: endDate });
            const response = await fetch(`${getApiBase()}/studentplayground/api/users-for-${channel}-selection/?${query}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` },
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || `Failed to load ${studentGroup.toLowerCase()}`);
            if (version !== requestVersion) return;
            appliedRange = range;
            dispatch('recipients', (inactive ? data.inactive_students : data.active_students) || []);
        } catch (error) {
            if (version === requestVersion) errorMessage = error.message;
        } finally {
            if (version === requestVersion) isLoading = false;
        }
    }

    onDestroy(() => { requestVersion += 1; });
</script>

<div class="date-range-filter">
    <p>{inactive ? 'Students with no scheduled classes' : 'Students with at least one scheduled class'} in the chosen dates (Vilnius time), including both dates. Cancelled classes and cancelled student places are excluded.</p>
    <div class="date-range-controls">
        <label>Start date <input type="date" bind:value={startDate} on:input={resetRange} /></label>
        <label>End date <input type="date" bind:value={endDate} on:input={resetRange} /></label>
        <button type="button" on:click={applyRange} disabled={isLoading}>Apply date range</button>
    </div>
    {#if isLoading}<p role="status">Loading {studentGroup.toLowerCase()}...</p>{/if}
    {#if appliedRange}<p role="status">{studentGroup}: {appliedRange}</p>{/if}
    {#if errorMessage}<p role="alert">{errorMessage}</p>{/if}
</div>

<style>
    .date-range-filter { margin: 0 0 1rem; padding: 1rem; border: 1px solid #ddd; border-radius: 6px; }
    p { margin: 0 0 0.75rem; }
    .date-range-controls { display: flex; flex-wrap: wrap; align-items: end; gap: 0.75rem; }
    label { display: flex; flex-direction: column; gap: 0.3rem; }
    input, button { padding: 0.6rem; font: inherit; border: 1px solid #aaa; border-radius: 4px; }
    button { cursor: pointer; background: #f5f5f5; }
    button:disabled { cursor: wait; opacity: 0.6; }
    [role='alert'] { color: #b42318; margin-top: 0.75rem; }
    [role='status'] { margin-top: 0.75rem; }
</style>
